export default __webpack_public_path__ + "static/goods-5-ce7239bd536cd1b25e2c6519f8fe2bd1.png";